// IMP-307: Admin 목록 화면 상태 보존(page/정렬/검색/필터/트리)용 stateKey 단일 정의(SSoT).
// 키 추가/리네임 시 이 파일만 수정. AdminLeftMenu(메뉴 진입 시 Clear)와 각 Admin*List(stateKey prop)가 공유.

export const LIST_STATE_KEYS = {
    ADMIN_PRODUCT: 'adminProduct',
    ADMIN_SERVICE: 'adminService',
    ADMIN_SITE: 'adminSite',
    ADMIN_ERROR: 'adminError',
    ADMIN_INSTALLATION: 'adminInstallation',
    ADMIN_SITE_SURVEY: 'adminSiteSurvey',
    ADMIN_PRODUCT_STOCK: 'adminProductStock',
    ADMIN_USER: 'adminUser',
    ADMIN_ERROR_CODE: 'adminErrorCode',
    ADMIN_COMPANY: 'adminCompany',
    ADMIN_RAY_DATA: 'adminRayData',
    ADMIN_CUSTOM_FIELD: 'adminCustomField',
    ADMIN_SPARE_PARTS_OUT: 'adminSparePartsOut',
    ADMIN_SPARE_PARTS_ORDER: 'adminSparePartsOrder',
    ADMIN_SPARE_PARTS: 'adminSpareParts',
    ADMIN_SPARE_PARTS_COMPANY: 'adminSparePartsCompany',
    ADMIN_RAY_CODE: 'adminRayCode',
    ADMIN_PRODUCT_PART: 'adminProductPart',
    ADMIN_SPARE_PARTS_ORDER_MANAGER: 'adminSparePartsOrderListManager',
};

// 목록 경로 → stateKey (AdminLeftMenu 메뉴 진입 시 해당 목록 상태 Clear)
export const LINK_STATE_KEY_MAP = {
    '/Admin/AdminProductList': LIST_STATE_KEYS.ADMIN_PRODUCT,
    '/Admin/AdminServiceList': LIST_STATE_KEYS.ADMIN_SERVICE,
    '/Admin/AdminSiteList': LIST_STATE_KEYS.ADMIN_SITE,
    '/Admin/AdminErrorList': LIST_STATE_KEYS.ADMIN_ERROR,
    '/Admin/AdminInstallationList': LIST_STATE_KEYS.ADMIN_INSTALLATION,
    '/Admin/AdminSiteSurveyList': LIST_STATE_KEYS.ADMIN_SITE_SURVEY,
    '/Admin/AdminProductStockList': LIST_STATE_KEYS.ADMIN_PRODUCT_STOCK,
    '/Admin/AdminUserList': LIST_STATE_KEYS.ADMIN_USER,
    '/Admin/AdminErrorCodeList': LIST_STATE_KEYS.ADMIN_ERROR_CODE,
    '/Admin/AdminCompanyList': LIST_STATE_KEYS.ADMIN_COMPANY, // RayTable 없이 RayTreeview만 사용 — 트리 검색/선택 상태(.tree)만 보존.
    '/Admin/AdminRayDataList': LIST_STATE_KEYS.ADMIN_RAY_DATA,
    '/Admin/AdminCustomFieldList': LIST_STATE_KEYS.ADMIN_CUSTOM_FIELD,
    '/Admin/AdminSparePartsOutList': LIST_STATE_KEYS.ADMIN_SPARE_PARTS_OUT,
    '/Admin/AdminSparePartsOrderList': LIST_STATE_KEYS.ADMIN_SPARE_PARTS_ORDER,
    // 왼쪽 메뉴 진입 경로(SparePartsMenuLink: 본사=AdminSpareParts, 딜러=AdminSparePartsCompany, RayCode/ProductPart 는 su 메뉴).
    // AdminSparePartsOrderListManager 는 스페어파츠 탭으로만 진입하므로 메뉴 Clear 대상이 아니다.
    '/Admin/AdminSpareParts': LIST_STATE_KEYS.ADMIN_SPARE_PARTS,
    '/Admin/AdminSparePartsCompany': LIST_STATE_KEYS.ADMIN_SPARE_PARTS_COMPANY,
    '/Admin/AdminRayCode': LIST_STATE_KEYS.ADMIN_RAY_CODE,
    '/Admin/AdminProductPart': LIST_STATE_KEYS.ADMIN_PRODUCT_PART,
};
